import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-130893f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-dialog__title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "发票类目", -1))
const _hoisted_3 = { style: {"display":"flex","align-items":"center","flex-wrap":"wrap"} }
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = { key: 0 }

import { ref, nextTick, watchEffect } from 'vue';
import {
  BaseTag,
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseIcon
} from 'xrk-components';
import { BasicInformationData } from '@V/invoice/src/data-source/types';
import {
  deleteInvoiceCate,
  editInvoiceCate
} from '@V/invoice/src/data-source/apis';
import { Edit } from '@element-plus/icons-vue';

type ItemList = BasicInformationData['itemList'];


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-enterprise-dialog-category',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } },
    value: {}
  },
  setup(__props: any) {

const props = __props;

const formData = ref<ItemList>(props.value || []);
const inputValue = ref('');
const inputVisible = ref(false);
const inputRef = ref(null);
const disabled = ref(false); // false可编辑并按钮变为保存
const editInfo = ref({
  index: -1,
  value: ''
});

watchEffect(() => {
  formData.value = props.value || [];
});

const onShowAddInput = () => {
  inputVisible.value = true;
  nextTick(() => {
    inputRef.value?.focus();
  });
};

const onShowInput = index => {
  editInfo.value.index = index;
  editInfo.value.value = formData.value[index].itemName;
};
const onBlurTag = async () => {
  // 有输入值，则修改formData
  if (editInfo.value.value) {
    const curData = formData.value[editInfo.value.index];
    curData.itemName = editInfo.value.value;
    editInvoiceCate({
      id: curData.id,
      itemName: curData.itemName
    });
  }
  editInfo.value.index = -1;
};
const onRemove = async (index: number) => {
  editInfo.value.index = -1;
  await deleteInvoiceCate({ id: formData.value[index].id });
  formData.value.splice(index, 1);
};
const onInputConfirm = async () => {
  if (inputValue.value) {
    const { data } = await editInvoiceCate({
      itemName: inputValue.value
    });
    formData.value.push({ id: data, itemName: inputValue.value });
  }
  inputVisible.value = false;
  inputValue.value = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    class: "invoice-enterprise-dialog-category",
    ref: "formRef",
    "label-position": "top",
    model: formData.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (!disabled.value && formData.value.length < 20)
          ? (_openBlock(), _createBlock(_unref(BaseButton), {
              key: 0,
              size: "small",
              type: "primary2",
              onClick: onShowAddInput
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 新增 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(BaseFormItem), {
        prop: "id",
        label: " ",
        style: {"margin-top":"-30px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value, (tag, index) => {
              return (_openBlock(), _createBlock(_unref(BaseTag), {
                style: {"margin-right":"8px","margin-bottom":"15px"},
                key: tag.id,
                closable: !disabled.value,
                onClose: ($event: any) => (onRemove(index))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (index !== editInfo.value.index)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(tag.itemName), 1))
                      : (_openBlock(), _createBlock(_unref(BaseInput), {
                          key: 1,
                          type: "text",
                          min: 1,
                          max: 10,
                          modelValue: editInfo.value.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editInfo.value.value) = $event)),
                          onKeyup: _withKeys(onBlurTag, ["enter"]),
                          onBlur: onBlurTag
                        }, null, 8, ["modelValue"])),
                    (!disabled.value)
                      ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                          key: 2,
                          style: {"font-size":"32px","margin-left":"10px"},
                          onClick: ($event: any) => (onShowInput(index))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Edit))
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["closable", "onClose"]))
            }), 128)),
            (inputVisible.value)
              ? (_openBlock(), _createBlock(_unref(BaseTag), {
                  key: 0,
                  style: {"margin-right":"8px","margin-bottom":"15px"},
                  closable: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseInput), {
                      ref_key: "inputRef",
                      ref: inputRef,
                      size: "small",
                      modelValue: inputValue.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event)),
                      onKeyup: _withKeys(onInputConfirm, ["enter"]),
                      onBlur: onInputConfirm
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})